export default "__VITE_ASSET__Dr$EoCFL__";